import { useState } from 'react';
import { colors } from './styles';

export default function ApiConfig({ baseUrl, onSet }) {
  const [input, setInput] = useState(baseUrl);
  const [saved, setSaved]  = useState(false);

  const confirm = () => {
    onSet(input.replace(/\/$/, ''));
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10,
        background: colors.bgInput, border: `1px solid ${colors.border}`,
        borderRadius: 10, padding: '10px 14px',
      }}>
        <label style={{
          fontSize: 11, fontWeight: 700, color: colors.textLight,
          textTransform: 'uppercase', letterSpacing: '0.8px', whiteSpace: 'nowrap',
        }}>
          API URL
        </label>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && confirm()}
          placeholder="https://..."
          style={{
            flex: 1, border: 'none', outline: 'none', fontSize: 13,
            background: 'transparent', color: colors.text,
            fontFamily: "'JetBrains Mono', monospace",
          }}
        />
        <button
          onClick={confirm}
          style={{
            fontSize: 12, padding: '6px 14px',
            border: `1px solid ${saved ? colors.success : colors.border}`,
            borderRadius: 7,
            background: saved ? colors.successBg : 'transparent',
            cursor: 'pointer',
            color: saved ? colors.success : colors.textMuted,
            fontWeight: 600, transition: 'all 0.2s ease',
          }}
        >
          {saved ? '✓ Saved' : 'Set'}
        </button>
      </div>
    </div>
  );
}
